import { inject } from 'mobx-react';
import * as React from 'react';

import { usePropertyListing } from 'src/common/stores/contexts';

import { UitkMark, UitkMarkSize } from 'uitk-react-mark';

export interface PropertyReviewsProps {
  localizedCountWithLabel?: string;
  localizedOverallRating?: string;
  superlative?: string;
  mark?: any;
  localizedSubtitleA11yLabel?: string;
}

export interface SearchResultsReviewsProps {
  className?: string | string[];
}

export interface SuperlativeProps {
  superlative: string;
}

const SearchResultsReviewsComponent: React.FunctionComponent<SearchResultsReviewsProps> = ({ className }) => {
  const { reviews } = usePropertyListing();

  if (!reviews) {
    return null;
  }

  const { localizedScore, localizedSubtitleA11y, localizedTotal, mark, superlative } = reviews;

  return (
    <div className={`${className}`} data-stid="search-results-reviews">
      {reviews && (
        <PropertyReviews
          localizedCountWithLabel={localizedTotal}
          localizedOverallRating={localizedScore}
          superlative={superlative}
          mark={mark}
          localizedSubtitleA11yLabel={localizedSubtitleA11y?.accessibilityLabel}
        />
      )}
    </div>
  );
};
SearchResultsReviewsComponent.displayName = 'SearchResultsReviewsComponent';

export const PropertyReviews: React.FC<PropertyReviewsProps> = inject('experiment')(
  ({ localizedCountWithLabel, localizedOverallRating, superlative, mark, localizedSubtitleA11yLabel }) => (
    <div data-stid="content-hotel-review-info">
      <span data-stid="localized-subtitle-visual-label" aria-hidden="true">
        {mark?.id && (
          <UitkMark
            name={mark.id}
            size={UitkMarkSize.SMALL}
            className="messaging-card__title-icon all-r-margin-one all-cell-align-middle"
          />
        )}
        {localizedOverallRating && (
          <span className="uitk-type-300 uitk-type-bold all-r-padding-one" data-stid="content-hotel-reviews-rating">
            {localizedOverallRating}
            /5
          </span>
        )}
        {superlative && <Superlative superlative={superlative} />}
        {localizedCountWithLabel && (
          <span className="pwa-theme--grey-700" data-stid="content-hotel-reviews-total">
            ({localizedCountWithLabel})
          </span>
        )}
      </span>
      {localizedSubtitleA11yLabel && (
        <span data-stid="localized-subtitle-a11y-label" className="is-visually-hidden">
          {localizedSubtitleA11yLabel}
        </span>
      )}
    </div>
  )
);
PropertyReviews.displayName = 'PropertyReviews';

export const Superlative = ({ superlative }: SuperlativeProps) => (
  <span className="uitk-type-300 pwa-theme--grey-700 all-r-padding-one" data-stid="content-hotel-reviews-superlative">
    {superlative}
  </span>
);
Superlative.displayName = 'Superlative';

export const SearchResultsReviews = inject('context')(SearchResultsReviewsComponent) as React.ComponentType<SearchResultsReviewsProps>;
